import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { FONT_ENUM } from '../../../types/global/fonts.types';
import { BRAND_LUXE_PRIMARY, BRAND_OUTLINE_VARIANT, BRAND_SURFACE_CONTAINER } from '../brandDashboardTokens';

export interface CampaignReportPaginationProps {
    page: number;
    totalPages: number;
    total: number;
    onPageChange: (page: number) => void;
    label?: string;
}

export function CampaignReportPagination({
    page,
    totalPages,
    total,
    onPageChange,
    label = 'items',
}: CampaignReportPaginationProps) {
    if (totalPages <= 1) return null;

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 2,
                flexWrap: 'wrap',
                mt: 2,
                p: 2,
                borderRadius: 2,
                bgcolor: BRAND_SURFACE_CONTAINER,
                border: `1px solid ${BRAND_OUTLINE_VARIANT}33`,
            }}>
            <Typography sx={{ fontFamily: FONT_ENUM.MAIN_MEDIUM, fontSize: 13, color: 'rgba(255,255,255,0.55)' }}>
                Page {page} of {totalPages} · {total} {label}
            </Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
                <Button
                    size="small"
                    disabled={page <= 1}
                    startIcon={<ChevronLeftIcon />}
                    onClick={() => onPageChange(page - 1)}
                    sx={{
                        textTransform: 'none',
                        color: BRAND_LUXE_PRIMARY,
                        '&.Mui-disabled': { color: 'rgba(255,255,255,0.25)' },
                    }}>
                    Previous
                </Button>
                <Button
                    size="small"
                    disabled={page >= totalPages}
                    endIcon={<ChevronRightIcon />}
                    onClick={() => onPageChange(page + 1)}
                    sx={{
                        textTransform: 'none',
                        color: BRAND_LUXE_PRIMARY,
                        '&.Mui-disabled': { color: 'rgba(255,255,255,0.25)' },
                    }}>
                    Next
                </Button>
            </Box>
        </Box>
    );
}
